if (!customElements.get('slider-default')) {
  class SliderDefault extends HTMLElement {
    constructor() {
      super();

      this.thumbs = this.querySelector('[data-thumbs]');
      this.counterCurrent = this.querySelector('[data-counter-current]');
      this.mouseLeaveDelay = null;

      this.sliderOptions = {
        speed: this.dataset.speed || 300,
        effect: this.dataset.effect || 'slide',
        slidesPerView: 'auto',
        allowTouchMove: !this.hasAttribute('data-disable-mobile'),
        centeredSlides: this.hasAttribute('data-center-slides'),
        freeMode: this.hasAttribute('data-freemode'),
        loop: this.hasAttribute('data-loop'),
        slideToClickedSlide: this.hasAttribute('data-slide-to-clicked'),
        initialSlide: +this.dataset.initialSlide || 0,
        autoHeight: this.hasAttribute('data-auto-height'),
        breakpoints: {
          750: {
            allowTouchMove: !this.hasAttribute('data-disable-desktop'),
            centeredSlides: this.hasAttribute('data-center-desktop'),
          },
        },
      };

      if (this.hasAttribute('data-disabled')) return;

      this.initSlider();
    }

    initSlider() {
      const pagination = this.querySelector('[data-pagination]');
      const nextEl = this.querySelector('[data-next]');
      const prevEl = this.querySelector('[data-prev]');

      this.sliderOptions.pagination = {
        el: pagination,
        type: 'bullets',
        clickable: true,
      };

      this.sliderOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };

      if (this.thumbs) {
        const thumbsSlider = this.querySelector('[data-thumbs-slider]');
        const thumbsNext = this.querySelector('[data-thumbs-next]');
        const thumbsPrev = this.querySelector('[data-thumbs-prev]');

        this.thumbsSlider = new Swiper(thumbsSlider, {
          slidesPerView: 'auto',
          navigation: {
            nextEl: thumbsNext,
            prevEl: thumbsPrev,
          },
        });

        this.sliderOptions.thumbs = {
          swiper: this.thumbsSlider,
          autoScrollOffset: 1,
        };
      }

      if (this.hasAttribute('data-autoplay')) {
        this.sliderOptions.autoplay = {
          delay: this.dataset.autoplay,
          disableOnInteraction: !this.hasAttribute('data-pause-on-hover'),
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.sliderOptions,
      );

      if (this.hasAttribute('data-autoplay')) {
        if (this.hasAttribute('data-pause-on-hover')) this.setPauseOnHover();
        if (this.hasAttribute('data-auto-height')) this.setPauseWhenOutOfView();
      }

      if (!this.counterCurrent) return;

      this.slider.on('slideChange', () => {
        this.counterCurrent.textContent = this.slider.realIndex + 1;
      });
    }

    setPauseOnHover() {
      this.addEventListener('mouseover', (e) => {
        if (!e.target.closest('[data-pause-target]')) return;

        clearTimeout(this.mouseLeaveDelay);
        this.slider?.autoplay.stop();
      });

      this.addEventListener('mouseout', (e) => {
        if (!e.target.closest('[data-pause-target]')) return;

        this.mouseLeaveDelay = setTimeout(
          () => this.slider?.autoplay.start(),
          100,
        );
      });

      this.addEventListener(
        'touchstart',
        (e) => {
          if (e.target.closest('[data-pause-target]'))
            this.slider?.autoplay.stop();
        },
        { passive: true },
      );

      this.addEventListener(
        'touchend',
        (e) => {
          if (e.target.closest('[data-pause-target]'))
            this.slider?.autoplay.start();
        },
        { passive: true },
      );

      this.addEventListener(
        'touchmove',
        () => {
          this.slider?.autoplay.start();
        },
        { passive: true },
      );
    }

    setPauseWhenOutOfView() {
      this.outOfViewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting
              ? this.slider?.autoplay.start()
              : this.slider?.autoplay.stop();
          });
        },
        { threshold: 0.5 },
      );

      this.outOfViewObserver.observe(this);
    }
  }

  customElements.define('slider-default', SliderDefault);
}
